import { IGetItemsResult } from '~src/ts/ServerApi/types/IGetItemsResult';
import { IPagedItemsParams } from '~src/ts/ServerApi/types/IPage';

import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../ts/services/RestApiService';
import { IConnectedApplicationType } from '../types/ConnectedApplicationType';

// We don't actually support paging yet so the IGetItemsResult isnt really needed
export interface IGetConnectedApplicationsResult extends IGetItemsResult {
  connectedApplications: {
    connectedApplication: IConnectedApplicationType[];
  };
}

function getConnectedApplicationsRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.14',
    httpMethod: 'GET',
    endpoint: 'connected-applications',
    serverWideRequest: false
  };
}

export function callGetConnectedApplications(params: IPagedItemsParams) {
  return makeJsonRestApiRequest<void, IGetConnectedApplicationsResult>({
    config: getConnectedApplicationsRequestConfig(),
    request: null,
  });
}

